import { render, staticRenderFns } from "./wechatModal.vue?vue&type=template&id=21ac22f6&scoped=true&"
import script from "./wechatModal.vue?vue&type=script&lang=js&"
export * from "./wechatModal.vue?vue&type=script&lang=js&"
import style0 from "./wechatModal.vue?vue&type=style&index=0&id=21ac22f6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ac22f6",
  null
  
)

export default component.exports